import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-reset-filter-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './reset-filter-button.component.html',
  styleUrl: './reset-filter-button.component.scss',
})
export class ResetFilterButtonComponent {
  readonly label = input.required<string>();
  readonly disabled = input<boolean>(false);

  readonly resetClick = output<void>();

  onClick(): void {
    this.resetClick.emit();
  }
}
